const styles = {
  paper: {
    overflow: 'hidden',
  },
  topContainer: {display: 'flex', flexDirection: 'row', alignItems: 'center'},
  rowContainer: {
    flexDirection: 'row',
    display: 'flex',
    flex: 1,
    alignItems: 'center',
  },
};

export default styles;
